import React, { useEffect, useState } from 'react'
import LayoutAdmin from '../../components/layout_admin'
import { fetchItems, deleteItems, disable, enable, fetchAll } from '../../../flux/items'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import Skeleton from './skeleton'
import PageTitle from '../../components/page_title'
import Article from '../../components/Article'
import styled from 'styled-components'
import { setAlert } from '../../../flux/alert'
import Admin from '../../hoc/admin'
import lastPosition from '../../../helpers/last_position'
import { CircularProgress, Button, Hidden, Box } from '@material-ui/core'
import { setNotification } from '../../../flux/notification'
import { toArray } from '../../../helpers/transformer'
import Search from './search'
import NotFound from './notFound'
import useShippingCost from '../../../hooks/useShippingCost'
import currency from '../../../helpers/currency'
import { Edit } from '@material-ui/icons'
import EditShippingCost from './edit'

const MyArticles = () => {
  var { loading, items, isfinally } = useSelector(state => state.items)
  items = toArray(items)
  const history = useHistory()
  const dispatch = useDispatch()
  const [query, setQuery] = useState('')
  items = items.filter(item => item.title.toLowerCase().includes(query.toLowerCase()))
  const [isDialogOpen, setDialo] = useState(false)
  const shipingCost = useShippingCost([isDialogOpen])

  useEffect(() => {
    if (items.length === 0) {
      dispatch(fetchItems())
    }
  }, [dispatch])

  const handleEdit = (data) => {
    history.push('/create-item', JSON.parse(JSON.stringify(data)))
  }

  const handleDelete = (data) => {
    dispatch(setAlert({
      title: 'Seguro que quieres borrar este producto',
      message: 'Una vez realizada esta accion no podras recurar la informacion',
      action: deleteItems(data.id),
      textAction: 'Eliminar'
    }))
  }

  const handleStatus = data => {
    if (data.isActive) {
      dispatch(setAlert({
        title: '¿Seguro quieres desactivar este producto?',
        message: 'Los productos desactivados no serán visibles para tus clientes.',
        action: dispatch => {
          dispatch(disable(data.id))
          dispatch(setNotification({
            message: 'El producto se ha desactivado',
            type: 'warning'
          }))
        },
        textAction: 'Desactivar'
      }))
    } else {
      dispatch(dispatch => {
        dispatch(enable(data.id))
        dispatch(setNotification({
          message: 'El producto se ha activado',
          type: 'info'
        }))
      })
    }
  }

  useEffect(event => {
    const handleScroll = event => {
      const isInLastPosition = lastPosition(500)
      if (!loading && isInLastPosition && !isfinally) {
        dispatch(fetchItems())
      }
    }
    window.addEventListener('scroll', handleScroll)
    return event => window.removeEventListener('scroll', handleScroll)
  }, [loading, isfinally, dispatch])

  const onQueryChange = event => {
    if (!isfinally && !loading) {
      dispatch(fetchAll())
    }
    setQuery(event.target.value)
  }

  return (
    <LayoutAdmin title='Mis Productos'>
      <EditShippingCost
        open={isDialogOpen}
        shippingCost={shipingCost}
        onClose={event => setDialo(false)}
      />
      <Hidden smUp>
        <Box mb={2}>
          <div>
            <span style={{ fontSize: '1.2em', marginRight: '10px' }}>
              Costo de envío:
            </span>
            <Button onClick={event => setDialo(true)} endIcon={<Edit />} variant='outlined' color='secondary'>$ {currency.formatMoney(shipingCost)}</Button>
          </div>
        </Box>
      </Hidden>
      <Header>
        <PageTitle>Mis Productos</PageTitle>
        <Hidden xsDown>
          <div>
            <span style={{ fontSize: '1.2em', marginRight: '10px' }}>
              Costo de envío:
            </span>
            <Button onClick={event => setDialo(true)} endIcon={<Edit />} variant='outlined' color='secondary'>$ {currency.formatMoney(shipingCost)}</Button>
          </div>
        </Hidden>
        <Search query={query} onQueryChange={onQueryChange} />
      </Header>
      {loading && items.length === 0 && (
        <Skeleton />
      )}
      {items.length > 0 && (
        <Content>
          {items.map(item => (
            <Article
              key={item.id}
              handleEdit={handleEdit}
              handleDelete={handleDelete}
              handleStatus={handleStatus}
              {...item}
            />
          ))}
        </Content>
      )}
      {items.length > 0 && loading && (
        <CircularProgressContet>
          <CircularProgress />
        </CircularProgressContet>
      )}
      {!items.length && !!query && !loading && (
        <NotFound
          message={`Sin resultados de busqueda para: "${query}"`}
        />
      )}
      {!items.length && !query && !loading && (
        <NotFound
          message='Aun no tienes productos publicados'
        />
      )}
    </LayoutAdmin>
  )
}

const Content = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-items: stretch;
`
const CircularProgressContet = styled.div`
  display: flex;
  justify-content: center;
  padding: 50px 0px;
`
const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 30px;
`
export default Admin(MyArticles)
